import { createElement } from "react";
import { createRoot } from "react-dom/client";

import App from "./src/App";

const container = document.getElementById("root");

if (null == container) {
  throw Error("Unable to find container");
}

const root = createRoot(container);
const children = createElement(App);

root.render(children);
